import { DtoExt } from '@/classes/scenario/DtoExt';
import { ScenarioStructureFinance } from '@/dto/scenario/ren-fr/structure-finance/ScenarioStructureFinance';

export class ScenarioStructureFinanceExt extends DtoExt {

  public crowdfunding: boolean | null = null;
  public linearDepreciationParticipative: boolean | null = null;
  public percentageOfCapex: number | null = null;
  public coShareholder1: boolean | null = null;
  public percentageOwnershipCoShareholder1: number | null = null;
  public coShareholder2: boolean | null = null;
  public percentageOwnershipCoShareholder2: number | null = null;
  public perRenSoldFarmDown: number | null = null;
  public minDSCR1: number | null = null;
  public minDSCR2: number | null = null;
  public minDSCR3: number | null = null;
  public maxBankDebtPercentage: number | null = null;

  private static fieldList = [
    'crowdfunding',
    'linearDepreciationParticipative',
    'percentageOfCapex',
    'coShareholder1',
    'percentageOwnershipCoShareholder1',
    'coShareholder2',
    'percentageOwnershipCoShareholder2',
    'perRenSoldFarmDown'
  ];

  constructor(options?: Partial<ScenarioStructureFinanceExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public static fromDto(dto: ScenarioStructureFinance): ScenarioStructureFinanceExt {
    return new ScenarioStructureFinanceExt(Object.fromEntries(
      this.fieldList
        // eslint-disable-next-line
        .filter(k => dto.hasOwnProperty(k as keyof ScenarioStructureFinance))
        .map((k) => [k, dto[k as keyof ScenarioStructureFinance]])
    ));
  }

  public toDto(): ScenarioStructureFinance {
    return new ScenarioStructureFinance(Object.fromEntries(
      ScenarioStructureFinanceExt.fieldList
        // eslint-disable-next-line
        .filter(k => this.hasOwnProperty(k as keyof ScenarioStructureFinanceExt))
        .map((k) => [k, this[k as keyof ScenarioStructureFinanceExt]])
    ));
  }

}
